export function createAdaptiveViewportMixin(options = {}) {
  const {
    designWidth = 1440,
    designHeight = 900,
    minScale = 0.58,
    mobileBreakpoint = 768,
    fitContentHeight = false
  } = options

  return {
    mounted() {
      this.__adaptiveViewportDocumentStyleCache = {
        documentOverflow: document.documentElement.style.overflow,
        documentWidth: document.documentElement.style.width,
        documentHeight: document.documentElement.style.height,
        documentBackground: document.documentElement.style.background,
        bodyOverflow: document.body.style.overflow,
        bodyWidth: document.body.style.width,
        bodyHeight: document.body.style.height,
        bodyBackground: document.body.style.background
      }
      this.__adaptiveViewportHandler = () => {
        this.$nextTick(() => {
          this.applyAdaptiveViewportScale()
        })
      }

      this.__adaptiveViewportHandler()
      window.addEventListener('resize', this.__adaptiveViewportHandler)
    },
    beforeDestroy() {
      if (this.__adaptiveViewportHandler) {
        window.removeEventListener('resize', this.__adaptiveViewportHandler)
      }
      this.resetAdaptiveViewportScale()
    },
    methods: {
      applyAdaptiveViewportScale() {
        const el = this.$el
        if (!el) {
          return
        }
        const pageBackground = window.getComputedStyle(el).background || ''

        const isMobile = window.innerWidth <= mobileBreakpoint
        if (isMobile) {
          document.documentElement.style.overflow = 'auto'
          document.documentElement.style.width = '100%'
          document.documentElement.style.height = '100%'
          document.documentElement.style.background = pageBackground
          document.body.style.overflow = 'hidden'
          document.body.style.width = '100%'
          document.body.style.height = '100%'
          document.body.style.background = pageBackground

          el.style.zoom = '1'
          el.style.transformOrigin = 'center top'
          el.style.width = '100%'
          el.style.height = 'auto'
          el.style.minHeight = '100%'
          el.style.overflow = 'visible'
          el.style.marginLeft = 'auto'
          el.style.marginRight = 'auto'
          return
        }

        const viewportWidth = Math.max(window.innerWidth || designWidth, 320)
        const viewportHeight = Math.max(window.innerHeight || designHeight, 560)
        let targetHeight = designHeight

        if (fitContentHeight) {
          const previousZoom = el.style.zoom
          const previousTransformOrigin = el.style.transformOrigin
          const previousWidth = el.style.width
          const previousHeight = el.style.height
          const previousMinHeight = el.style.minHeight
          const previousOverflow = el.style.overflow
          const previousMarginLeft = el.style.marginLeft
          const previousMarginRight = el.style.marginRight

          el.style.zoom = '1'
          el.style.transformOrigin = 'top left'
          el.style.width = `${designWidth}px`
          el.style.height = 'auto'
          el.style.minHeight = ''
          el.style.overflow = 'visible'
          el.style.marginLeft = '0'
          el.style.marginRight = '0'

          targetHeight = Math.max(
            designHeight,
            el.scrollHeight || 0,
            el.offsetHeight || 0
          )

          el.style.zoom = previousZoom
          el.style.transformOrigin = previousTransformOrigin
          el.style.width = previousWidth
          el.style.height = previousHeight
          el.style.minHeight = previousMinHeight
          el.style.overflow = previousOverflow
          el.style.marginLeft = previousMarginLeft
          el.style.marginRight = previousMarginRight
        }

        const widthScale = viewportWidth / designWidth
        const heightScale = viewportHeight / targetHeight
        const scale = Math.max(minScale, Math.min(widthScale, heightScale))
        const scaledWidth = designWidth * scale
        const horizontalMargin = Math.max((viewportWidth - scaledWidth) / 2 / scale, 0)

        const allowScrollWhenOverflow = Boolean(fitContentHeight)
        document.documentElement.style.overflowX = 'hidden'
        document.documentElement.style.overflowY = allowScrollWhenOverflow ? 'auto' : 'hidden'
        document.documentElement.style.width = '100%'
        document.documentElement.style.height = allowScrollWhenOverflow ? 'auto' : '100%'
        document.documentElement.style.background = pageBackground
        document.body.style.overflowX = 'hidden'
        document.body.style.overflowY = 'hidden'
        document.body.style.width = '100%'
        document.body.style.height = allowScrollWhenOverflow ? 'auto' : '100%'
        document.body.style.background = pageBackground

        el.style.zoom = String(scale)
        el.style.transformOrigin = 'top left'
        el.style.width = `${designWidth}px`
        el.style.height = allowScrollWhenOverflow ? 'auto' : `${targetHeight}px`
        el.style.minHeight = `${targetHeight}px`
        el.style.overflowX = 'hidden'
        el.style.overflowY = allowScrollWhenOverflow ? 'visible' : 'hidden'
        el.style.marginLeft = `${horizontalMargin}px`
        el.style.marginRight = `${horizontalMargin}px`
      },
      resetAdaptiveViewportScale() {
        const el = this.$el
        if (!el) {
          return
        }

        el.style.zoom = ''
        el.style.transformOrigin = ''
        el.style.width = ''
        el.style.height = ''
        el.style.minHeight = ''
        el.style.overflow = ''
        el.style.overflowX = ''
        el.style.overflowY = ''
        el.style.marginLeft = ''
        el.style.marginRight = ''

        const cache = this.__adaptiveViewportDocumentStyleCache || {}
        document.documentElement.style.overflow = cache.documentOverflow || ''
        document.documentElement.style.overflowX = ''
        document.documentElement.style.overflowY = ''
        document.documentElement.style.width = cache.documentWidth || ''
        document.documentElement.style.height = cache.documentHeight || ''
        document.documentElement.style.background = cache.documentBackground || ''
        document.body.style.overflow = cache.bodyOverflow || ''
        document.body.style.overflowX = ''
        document.body.style.overflowY = ''
        document.body.style.width = cache.bodyWidth || ''
        document.body.style.height = cache.bodyHeight || ''
        document.body.style.background = cache.bodyBackground || ''
      }
    }
  }
}
